// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v3.12.4
// source: aurora/map.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { LatLngBBox, MultiPolygon, ViewBox } from "../bgsearch/bgsearch_types";
import { Struct } from "../google/protobuf/struct";
import { AuroraError, Status, statusFromJSON, statusToJSON } from "./common";
import { FilterObject, LimitOffset, OrderBy } from "./filter";

export const protobufPackage = "biggeo.aurora";

export enum DbColumnType {
  NUMBER = 0,
  STRING = 1,
  BOOLEAN = 2,
  DATE = 3,
  STRUCTURED = 4,
  GEOSPATIAL = 5,
  OTHER = 6,
  UNRECOGNIZED = -1,
}

export function dbColumnTypeFromJSON(object: any): DbColumnType {
  switch (object) {
    case 0:
    case "NUMBER":
      return DbColumnType.NUMBER;
    case 1:
    case "STRING":
      return DbColumnType.STRING;
    case 2:
    case "BOOLEAN":
      return DbColumnType.BOOLEAN;
    case 3:
    case "DATE":
      return DbColumnType.DATE;
    case 4:
    case "STRUCTURED":
      return DbColumnType.STRUCTURED;
    case 5:
    case "GEOSPATIAL":
      return DbColumnType.GEOSPATIAL;
    case 6:
    case "OTHER":
      return DbColumnType.OTHER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DbColumnType.UNRECOGNIZED;
  }
}

export function dbColumnTypeToJSON(object: DbColumnType): string {
  switch (object) {
    case DbColumnType.NUMBER:
      return "NUMBER";
    case DbColumnType.STRING:
      return "STRING";
    case DbColumnType.BOOLEAN:
      return "BOOLEAN";
    case DbColumnType.DATE:
      return "DATE";
    case DbColumnType.STRUCTURED:
      return "STRUCTURED";
    case DbColumnType.GEOSPATIAL:
      return "GEOSPATIAL";
    case DbColumnType.OTHER:
      return "OTHER";
    case DbColumnType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface StringAttributes {
  list: string[];
  total: number;
}

export interface NumberAttributes {
  min: number;
  max: number;
}

export interface ColumnAttributes {
  string?: StringAttributes | undefined;
  number?: NumberAttributes | undefined;
}

export interface SchemaRow {
  columnName: string;
  dataType: DbColumnType;
  attributes?: ColumnAttributes | undefined;
}

export interface SchemaReq {
  datasetId: string;
  organizationId: string;
  collection: string;
}

export interface SchemaRsp {
  status: Status;
  success?: SchemaRspSuccess | undefined;
  err?: AuroraError | undefined;
}

export interface SchemaRspSuccess {
  rows: SchemaRow[];
}

export interface DataRsp {
  status: Status;
  success?: DataRspSuccess | undefined;
  err?: AuroraError | undefined;
}

export interface DataRspSuccess {
  count: number;
  rows: { [key: string]: any }[];
}

export interface DataReq {
  filters: FilterObject | undefined;
  viewport?: LatLngBBox | undefined;
  multipolygon?: MultiPolygon | undefined;
  limitOffset: LimitOffset | undefined;
  order?: OrderBy | undefined;
  geographyColumn?: string | undefined;
}

export interface DatasetStatisticsRsp {
  status: Status;
  success?: DatasetStatisticsRspSuccess | undefined;
  err?: AuroraError | undefined;
}

export interface DatasetStatisticsRspSuccess {
  column?: string | undefined;
  geometry: string[];
  total: number;
  totalRows: number;
  datasetId: string;
  organizationId: string;
  collection: string;
}

export interface DatasetStatisticsReq {
  column?: string | undefined;
  filters: DatasetStatisticsFilters | undefined;
  resolution?: number | undefined;
  datasetId: string;
  organizationId: string;
  collection: string;
}

export interface DatasetStatisticsFilters {
  multipolygon?: MultiPolygon | undefined;
  polygon?: ViewBox | undefined;
}

export interface DatasetSampleReq {
  dataSourceId: string;
  organizationId: string;
  maxRows: number;
  maxPercentage: number;
  sampleId: string;
  dggsColumn: string;
  polygon: ViewBox | undefined;
  resolution?: number | undefined;
  collection: string;
  sampleDataSourceId: string;
}

export interface DatasetSampleRsp {
  status: Status;
  success?: DatasetSampleRspSuccess | undefined;
  err?: AuroraError | undefined;
}

export interface DatasetSampleRspSuccess {
  dataSourceId: string;
  organizationId: string;
  sampleId: string;
  collection: string;
  sampleDataSourceId: string;
}

export interface DatasetSampleGenerationReq {
  dataPath: string;
  generatedFileName: string;
  dggsColumn: string;
  maxRows: number;
  maxPercentage: number;
  resolution?: number | undefined;
}

export interface PointDataRsp {
  status: Status;
  success?: PointDataRspSuccess | undefined;
  err?: AuroraError | undefined;
}

export interface PointDataRspSuccess {
  row: { [key: string]: any }[];
}

export interface PointDataReq {
  tableId: string;
  id: string;
  organizationId: string;
  databaseId: string;
  collection: string;
}

export interface DatasetLiveSampleReq {
  dataSourceId: string;
  organizationId: string;
  geographyColumn: string;
  dggsColumn: string;
  maxRows: number;
  maxPercentage: number;
  polygon: ViewBox | undefined;
  resolution?: number | undefined;
  collection: string;
}

export interface DatasetLiveSampleReqSubset {
  geographyColumn: string;
  dggsColumn: string;
  maxRows: number;
  maxPercentage: number;
  resolution?: number | undefined;
}

export interface DatasetLiveSampleRsp {
  status: Status;
  success?: DatasetLiveSampleRspSuccess | undefined;
  err?: AuroraError | undefined;
}

export interface DatasetLiveSampleGeometry {
  points: { [key: string]: any }[];
}

export interface DatasetLiveSampleRspSuccess {
  dataSourceId: string;
  organizationId: string;
  geometry: DatasetLiveSampleGeometry | undefined;
}

export interface DatasetLiveSampleGenerationReq {
  dataPath: string;
  geographyColumn: string;
  dggsColumn: string;
  maxRows: number;
  maxPercentage: number;
  resolution?: number | undefined;
}

function createBaseStringAttributes(): StringAttributes {
  return { list: [], total: 0 };
}

export const StringAttributes: MessageFns<StringAttributes> = {
  encode(message: StringAttributes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.list) {
      writer.uint32(10).string(v!);
    }
    if (message.total !== 0) {
      writer.uint32(16).int32(message.total);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StringAttributes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStringAttributes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.list.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.total = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StringAttributes {
    return {
      list: globalThis.Array.isArray(object?.list) ? object.list.map((e: any) => globalThis.String(e)) : [],
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
    };
  },

  toJSON(message: StringAttributes): unknown {
    const obj: any = {};
    if (message.list?.length) {
      obj.list = message.list;
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StringAttributes>, I>>(base?: I): StringAttributes {
    return StringAttributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StringAttributes>, I>>(object: I): StringAttributes {
    const message = createBaseStringAttributes();
    message.list = object.list?.map((e) => e) || [];
    message.total = object.total ?? 0;
    return message;
  },
};

function createBaseNumberAttributes(): NumberAttributes {
  return { min: 0, max: 0 };
}

export const NumberAttributes: MessageFns<NumberAttributes> = {
  encode(message: NumberAttributes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== 0) {
      writer.uint32(13).float(message.min);
    }
    if (message.max !== 0) {
      writer.uint32(21).float(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NumberAttributes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNumberAttributes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.min = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.max = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NumberAttributes {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
    };
  },

  toJSON(message: NumberAttributes): unknown {
    const obj: any = {};
    if (message.min !== 0) {
      obj.min = message.min;
    }
    if (message.max !== 0) {
      obj.max = message.max;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NumberAttributes>, I>>(base?: I): NumberAttributes {
    return NumberAttributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NumberAttributes>, I>>(object: I): NumberAttributes {
    const message = createBaseNumberAttributes();
    message.min = object.min ?? 0;
    message.max = object.max ?? 0;
    return message;
  },
};

function createBaseColumnAttributes(): ColumnAttributes {
  return { string: undefined, number: undefined };
}

export const ColumnAttributes: MessageFns<ColumnAttributes> = {
  encode(message: ColumnAttributes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.string !== undefined) {
      StringAttributes.encode(message.string, writer.uint32(10).fork()).join();
    }
    if (message.number !== undefined) {
      NumberAttributes.encode(message.number, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnAttributes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnAttributes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.string = StringAttributes.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.number = NumberAttributes.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnAttributes {
    return {
      string: isSet(object.string) ? StringAttributes.fromJSON(object.string) : undefined,
      number: isSet(object.number) ? NumberAttributes.fromJSON(object.number) : undefined,
    };
  },

  toJSON(message: ColumnAttributes): unknown {
    const obj: any = {};
    if (message.string !== undefined) {
      obj.string = StringAttributes.toJSON(message.string);
    }
    if (message.number !== undefined) {
      obj.number = NumberAttributes.toJSON(message.number);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnAttributes>, I>>(base?: I): ColumnAttributes {
    return ColumnAttributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnAttributes>, I>>(object: I): ColumnAttributes {
    const message = createBaseColumnAttributes();
    message.string = (object.string !== undefined && object.string !== null)
      ? StringAttributes.fromPartial(object.string)
      : undefined;
    message.number = (object.number !== undefined && object.number !== null)
      ? NumberAttributes.fromPartial(object.number)
      : undefined;
    return message;
  },
};

function createBaseSchemaRow(): SchemaRow {
  return { columnName: "", dataType: 0, attributes: undefined };
}

export const SchemaRow: MessageFns<SchemaRow> = {
  encode(message: SchemaRow, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.columnName !== "") {
      writer.uint32(10).string(message.columnName);
    }
    if (message.dataType !== 0) {
      writer.uint32(16).int32(message.dataType);
    }
    if (message.attributes !== undefined) {
      ColumnAttributes.encode(message.attributes, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SchemaRow {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchemaRow();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.columnName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.dataType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.attributes = ColumnAttributes.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SchemaRow {
    return {
      columnName: isSet(object.columnName) ? globalThis.String(object.columnName) : "",
      dataType: isSet(object.dataType) ? dbColumnTypeFromJSON(object.dataType) : 0,
      attributes: isSet(object.attributes) ? ColumnAttributes.fromJSON(object.attributes) : undefined,
    };
  },

  toJSON(message: SchemaRow): unknown {
    const obj: any = {};
    if (message.columnName !== "") {
      obj.columnName = message.columnName;
    }
    if (message.dataType !== 0) {
      obj.dataType = dbColumnTypeToJSON(message.dataType);
    }
    if (message.attributes !== undefined) {
      obj.attributes = ColumnAttributes.toJSON(message.attributes);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SchemaRow>, I>>(base?: I): SchemaRow {
    return SchemaRow.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SchemaRow>, I>>(object: I): SchemaRow {
    const message = createBaseSchemaRow();
    message.columnName = object.columnName ?? "";
    message.dataType = object.dataType ?? 0;
    message.attributes = (object.attributes !== undefined && object.attributes !== null)
      ? ColumnAttributes.fromPartial(object.attributes)
      : undefined;
    return message;
  },
};

function createBaseSchemaReq(): SchemaReq {
  return { datasetId: "", organizationId: "", collection: "" };
}

export const SchemaReq: MessageFns<SchemaReq> = {
  encode(message: SchemaReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.datasetId !== "") {
      writer.uint32(10).string(message.datasetId);
    }
    if (message.organizationId !== "") {
      writer.uint32(18).string(message.organizationId);
    }
    if (message.collection !== "") {
      writer.uint32(26).string(message.collection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SchemaReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchemaReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.datasetId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SchemaReq {
    return {
      datasetId: isSet(object.datasetId) ? globalThis.String(object.datasetId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
    };
  },

  toJSON(message: SchemaReq): unknown {
    const obj: any = {};
    if (message.datasetId !== "") {
      obj.datasetId = message.datasetId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SchemaReq>, I>>(base?: I): SchemaReq {
    return SchemaReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SchemaReq>, I>>(object: I): SchemaReq {
    const message = createBaseSchemaReq();
    message.datasetId = object.datasetId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.collection = object.collection ?? "";
    return message;
  },
};

function createBaseSchemaRsp(): SchemaRsp {
  return { status: 0, success: undefined, err: undefined };
}

export const SchemaRsp: MessageFns<SchemaRsp> = {
  encode(message: SchemaRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.success !== undefined) {
      SchemaRspSuccess.encode(message.success, writer.uint32(18).fork()).join();
    }
    if (message.err !== undefined) {
      AuroraError.encode(message.err, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SchemaRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchemaRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.success = SchemaRspSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.err = AuroraError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SchemaRsp {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      success: isSet(object.success) ? SchemaRspSuccess.fromJSON(object.success) : undefined,
      err: isSet(object.err) ? AuroraError.fromJSON(object.err) : undefined,
    };
  },

  toJSON(message: SchemaRsp): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = statusToJSON(message.status);
    }
    if (message.success !== undefined) {
      obj.success = SchemaRspSuccess.toJSON(message.success);
    }
    if (message.err !== undefined) {
      obj.err = AuroraError.toJSON(message.err);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SchemaRsp>, I>>(base?: I): SchemaRsp {
    return SchemaRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SchemaRsp>, I>>(object: I): SchemaRsp {
    const message = createBaseSchemaRsp();
    message.status = object.status ?? 0;
    message.success = (object.success !== undefined && object.success !== null)
      ? SchemaRspSuccess.fromPartial(object.success)
      : undefined;
    message.err = (object.err !== undefined && object.err !== null) ? AuroraError.fromPartial(object.err) : undefined;
    return message;
  },
};

function createBaseSchemaRspSuccess(): SchemaRspSuccess {
  return { rows: [] };
}

export const SchemaRspSuccess: MessageFns<SchemaRspSuccess> = {
  encode(message: SchemaRspSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rows) {
      SchemaRow.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SchemaRspSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchemaRspSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rows.push(SchemaRow.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SchemaRspSuccess {
    return { rows: globalThis.Array.isArray(object?.rows) ? object.rows.map((e: any) => SchemaRow.fromJSON(e)) : [] };
  },

  toJSON(message: SchemaRspSuccess): unknown {
    const obj: any = {};
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => SchemaRow.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SchemaRspSuccess>, I>>(base?: I): SchemaRspSuccess {
    return SchemaRspSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SchemaRspSuccess>, I>>(object: I): SchemaRspSuccess {
    const message = createBaseSchemaRspSuccess();
    message.rows = object.rows?.map((e) => SchemaRow.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDataRsp(): DataRsp {
  return { status: 0, success: undefined, err: undefined };
}

export const DataRsp: MessageFns<DataRsp> = {
  encode(message: DataRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.success !== undefined) {
      DataRspSuccess.encode(message.success, writer.uint32(18).fork()).join();
    }
    if (message.err !== undefined) {
      AuroraError.encode(message.err, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.success = DataRspSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.err = AuroraError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataRsp {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      success: isSet(object.success) ? DataRspSuccess.fromJSON(object.success) : undefined,
      err: isSet(object.err) ? AuroraError.fromJSON(object.err) : undefined,
    };
  },

  toJSON(message: DataRsp): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = statusToJSON(message.status);
    }
    if (message.success !== undefined) {
      obj.success = DataRspSuccess.toJSON(message.success);
    }
    if (message.err !== undefined) {
      obj.err = AuroraError.toJSON(message.err);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataRsp>, I>>(base?: I): DataRsp {
    return DataRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataRsp>, I>>(object: I): DataRsp {
    const message = createBaseDataRsp();
    message.status = object.status ?? 0;
    message.success = (object.success !== undefined && object.success !== null)
      ? DataRspSuccess.fromPartial(object.success)
      : undefined;
    message.err = (object.err !== undefined && object.err !== null) ? AuroraError.fromPartial(object.err) : undefined;
    return message;
  },
};

function createBaseDataRspSuccess(): DataRspSuccess {
  return { count: 0, rows: [] };
}

export const DataRspSuccess: MessageFns<DataRspSuccess> = {
  encode(message: DataRspSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.count !== 0) {
      writer.uint32(16).int32(message.count);
    }
    for (const v of message.rows) {
      Struct.encode(Struct.wrap(v!), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataRspSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataRspSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.count = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rows.push(Struct.unwrap(Struct.decode(reader, reader.uint32())));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataRspSuccess {
    return {
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      rows: globalThis.Array.isArray(object?.rows) ? [...object.rows] : [],
    };
  },

  toJSON(message: DataRspSuccess): unknown {
    const obj: any = {};
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    if (message.rows?.length) {
      obj.rows = message.rows;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataRspSuccess>, I>>(base?: I): DataRspSuccess {
    return DataRspSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataRspSuccess>, I>>(object: I): DataRspSuccess {
    const message = createBaseDataRspSuccess();
    message.count = object.count ?? 0;
    message.rows = object.rows?.map((e) => e) || [];
    return message;
  },
};

function createBaseDataReq(): DataReq {
  return {
    filters: undefined,
    viewport: undefined,
    multipolygon: undefined,
    limitOffset: undefined,
    order: undefined,
    geographyColumn: undefined,
  };
}

export const DataReq: MessageFns<DataReq> = {
  encode(message: DataReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      FilterObject.encode(message.filters, writer.uint32(10).fork()).join();
    }
    if (message.viewport !== undefined) {
      LatLngBBox.encode(message.viewport, writer.uint32(18).fork()).join();
    }
    if (message.multipolygon !== undefined) {
      MultiPolygon.encode(message.multipolygon, writer.uint32(26).fork()).join();
    }
    if (message.limitOffset !== undefined) {
      LimitOffset.encode(message.limitOffset, writer.uint32(34).fork()).join();
    }
    if (message.order !== undefined) {
      OrderBy.encode(message.order, writer.uint32(42).fork()).join();
    }
    if (message.geographyColumn !== undefined) {
      writer.uint32(50).string(message.geographyColumn);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = FilterObject.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.viewport = LatLngBBox.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.multipolygon = MultiPolygon.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.limitOffset = LimitOffset.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.order = OrderBy.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.geographyColumn = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataReq {
    return {
      filters: isSet(object.filters) ? FilterObject.fromJSON(object.filters) : undefined,
      viewport: isSet(object.viewport) ? LatLngBBox.fromJSON(object.viewport) : undefined,
      multipolygon: isSet(object.multipolygon) ? MultiPolygon.fromJSON(object.multipolygon) : undefined,
      limitOffset: isSet(object.limitOffset) ? LimitOffset.fromJSON(object.limitOffset) : undefined,
      order: isSet(object.order) ? OrderBy.fromJSON(object.order) : undefined,
      geographyColumn: isSet(object.geographyColumn) ? globalThis.String(object.geographyColumn) : undefined,
    };
  },

  toJSON(message: DataReq): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = FilterObject.toJSON(message.filters);
    }
    if (message.viewport !== undefined) {
      obj.viewport = LatLngBBox.toJSON(message.viewport);
    }
    if (message.multipolygon !== undefined) {
      obj.multipolygon = MultiPolygon.toJSON(message.multipolygon);
    }
    if (message.limitOffset !== undefined) {
      obj.limitOffset = LimitOffset.toJSON(message.limitOffset);
    }
    if (message.order !== undefined) {
      obj.order = OrderBy.toJSON(message.order);
    }
    if (message.geographyColumn !== undefined) {
      obj.geographyColumn = message.geographyColumn;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataReq>, I>>(base?: I): DataReq {
    return DataReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataReq>, I>>(object: I): DataReq {
    const message = createBaseDataReq();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? FilterObject.fromPartial(object.filters)
      : undefined;
    message.viewport = (object.viewport !== undefined && object.viewport !== null)
      ? LatLngBBox.fromPartial(object.viewport)
      : undefined;
    message.multipolygon = (object.multipolygon !== undefined && object.multipolygon !== null)
      ? MultiPolygon.fromPartial(object.multipolygon)
      : undefined;
    message.limitOffset = (object.limitOffset !== undefined && object.limitOffset !== null)
      ? LimitOffset.fromPartial(object.limitOffset)
      : undefined;
    message.order = (object.order !== undefined && object.order !== null)
      ? OrderBy.fromPartial(object.order)
      : undefined;
    message.geographyColumn = object.geographyColumn ?? undefined;
    return message;
  },
};

function createBaseDatasetStatisticsRsp(): DatasetStatisticsRsp {
  return { status: 0, success: undefined, err: undefined };
}

export const DatasetStatisticsRsp: MessageFns<DatasetStatisticsRsp> = {
  encode(message: DatasetStatisticsRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.success !== undefined) {
      DatasetStatisticsRspSuccess.encode(message.success, writer.uint32(18).fork()).join();
    }
    if (message.err !== undefined) {
      AuroraError.encode(message.err, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetStatisticsRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetStatisticsRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.success = DatasetStatisticsRspSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.err = AuroraError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetStatisticsRsp {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      success: isSet(object.success) ? DatasetStatisticsRspSuccess.fromJSON(object.success) : undefined,
      err: isSet(object.err) ? AuroraError.fromJSON(object.err) : undefined,
    };
  },

  toJSON(message: DatasetStatisticsRsp): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = statusToJSON(message.status);
    }
    if (message.success !== undefined) {
      obj.success = DatasetStatisticsRspSuccess.toJSON(message.success);
    }
    if (message.err !== undefined) {
      obj.err = AuroraError.toJSON(message.err);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetStatisticsRsp>, I>>(base?: I): DatasetStatisticsRsp {
    return DatasetStatisticsRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetStatisticsRsp>, I>>(object: I): DatasetStatisticsRsp {
    const message = createBaseDatasetStatisticsRsp();
    message.status = object.status ?? 0;
    message.success = (object.success !== undefined && object.success !== null)
      ? DatasetStatisticsRspSuccess.fromPartial(object.success)
      : undefined;
    message.err = (object.err !== undefined && object.err !== null) ? AuroraError.fromPartial(object.err) : undefined;
    return message;
  },
};

function createBaseDatasetStatisticsRspSuccess(): DatasetStatisticsRspSuccess {
  return { column: undefined, geometry: [], total: 0, totalRows: 0, datasetId: "", organizationId: "", collection: "" };
}

export const DatasetStatisticsRspSuccess: MessageFns<DatasetStatisticsRspSuccess> = {
  encode(message: DatasetStatisticsRspSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column !== undefined) {
      writer.uint32(10).string(message.column);
    }
    for (const v of message.geometry) {
      writer.uint32(18).string(v!);
    }
    if (message.total !== 0) {
      writer.uint32(24).int32(message.total);
    }
    if (message.totalRows !== 0) {
      writer.uint32(32).int32(message.totalRows);
    }
    if (message.datasetId !== "") {
      writer.uint32(42).string(message.datasetId);
    }
    if (message.organizationId !== "") {
      writer.uint32(50).string(message.organizationId);
    }
    if (message.collection !== "") {
      writer.uint32(58).string(message.collection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetStatisticsRspSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetStatisticsRspSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.geometry.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.total = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.totalRows = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.datasetId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetStatisticsRspSuccess {
    return {
      column: isSet(object.column) ? globalThis.String(object.column) : undefined,
      geometry: globalThis.Array.isArray(object?.geometry) ? object.geometry.map((e: any) => globalThis.String(e)) : [],
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
      totalRows: isSet(object.totalRows) ? globalThis.Number(object.totalRows) : 0,
      datasetId: isSet(object.datasetId) ? globalThis.String(object.datasetId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
    };
  },

  toJSON(message: DatasetStatisticsRspSuccess): unknown {
    const obj: any = {};
    if (message.column !== undefined) {
      obj.column = message.column;
    }
    if (message.geometry?.length) {
      obj.geometry = message.geometry;
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    if (message.totalRows !== 0) {
      obj.totalRows = Math.round(message.totalRows);
    }
    if (message.datasetId !== "") {
      obj.datasetId = message.datasetId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetStatisticsRspSuccess>, I>>(base?: I): DatasetStatisticsRspSuccess {
    return DatasetStatisticsRspSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetStatisticsRspSuccess>, I>>(object: I): DatasetStatisticsRspSuccess {
    const message = createBaseDatasetStatisticsRspSuccess();
    message.column = object.column ?? undefined;
    message.geometry = object.geometry?.map((e) => e) || [];
    message.total = object.total ?? 0;
    message.totalRows = object.totalRows ?? 0;
    message.datasetId = object.datasetId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.collection = object.collection ?? "";
    return message;
  },
};

function createBaseDatasetStatisticsReq(): DatasetStatisticsReq {
  return {
    column: undefined,
    filters: undefined,
    resolution: undefined,
    datasetId: "",
    organizationId: "",
    collection: "",
  };
}

export const DatasetStatisticsReq: MessageFns<DatasetStatisticsReq> = {
  encode(message: DatasetStatisticsReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.column !== undefined) {
      writer.uint32(10).string(message.column);
    }
    if (message.filters !== undefined) {
      DatasetStatisticsFilters.encode(message.filters, writer.uint32(18).fork()).join();
    }
    if (message.resolution !== undefined) {
      writer.uint32(24).int32(message.resolution);
    }
    if (message.datasetId !== "") {
      writer.uint32(34).string(message.datasetId);
    }
    if (message.organizationId !== "") {
      writer.uint32(42).string(message.organizationId);
    }
    if (message.collection !== "") {
      writer.uint32(50).string(message.collection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetStatisticsReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetStatisticsReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.column = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.filters = DatasetStatisticsFilters.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.resolution = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.datasetId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetStatisticsReq {
    return {
      column: isSet(object.column) ? globalThis.String(object.column) : undefined,
      filters: isSet(object.filters) ? DatasetStatisticsFilters.fromJSON(object.filters) : undefined,
      resolution: isSet(object.resolution) ? globalThis.Number(object.resolution) : undefined,
      datasetId: isSet(object.datasetId) ? globalThis.String(object.datasetId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
    };
  },

  toJSON(message: DatasetStatisticsReq): unknown {
    const obj: any = {};
    if (message.column !== undefined) {
      obj.column = message.column;
    }
    if (message.filters !== undefined) {
      obj.filters = DatasetStatisticsFilters.toJSON(message.filters);
    }
    if (message.resolution !== undefined) {
      obj.resolution = Math.round(message.resolution);
    }
    if (message.datasetId !== "") {
      obj.datasetId = message.datasetId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetStatisticsReq>, I>>(base?: I): DatasetStatisticsReq {
    return DatasetStatisticsReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetStatisticsReq>, I>>(object: I): DatasetStatisticsReq {
    const message = createBaseDatasetStatisticsReq();
    message.column = object.column ?? undefined;
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? DatasetStatisticsFilters.fromPartial(object.filters)
      : undefined;
    message.resolution = object.resolution ?? undefined;
    message.datasetId = object.datasetId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.collection = object.collection ?? "";
    return message;
  },
};

function createBaseDatasetStatisticsFilters(): DatasetStatisticsFilters {
  return { multipolygon: undefined, polygon: undefined };
}

export const DatasetStatisticsFilters: MessageFns<DatasetStatisticsFilters> = {
  encode(message: DatasetStatisticsFilters, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.multipolygon !== undefined) {
      MultiPolygon.encode(message.multipolygon, writer.uint32(10).fork()).join();
    }
    if (message.polygon !== undefined) {
      ViewBox.encode(message.polygon, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetStatisticsFilters {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetStatisticsFilters();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.multipolygon = MultiPolygon.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.polygon = ViewBox.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetStatisticsFilters {
    return {
      multipolygon: isSet(object.multipolygon) ? MultiPolygon.fromJSON(object.multipolygon) : undefined,
      polygon: isSet(object.polygon) ? ViewBox.fromJSON(object.polygon) : undefined,
    };
  },

  toJSON(message: DatasetStatisticsFilters): unknown {
    const obj: any = {};
    if (message.multipolygon !== undefined) {
      obj.multipolygon = MultiPolygon.toJSON(message.multipolygon);
    }
    if (message.polygon !== undefined) {
      obj.polygon = ViewBox.toJSON(message.polygon);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetStatisticsFilters>, I>>(base?: I): DatasetStatisticsFilters {
    return DatasetStatisticsFilters.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetStatisticsFilters>, I>>(object: I): DatasetStatisticsFilters {
    const message = createBaseDatasetStatisticsFilters();
    message.multipolygon = (object.multipolygon !== undefined && object.multipolygon !== null)
      ? MultiPolygon.fromPartial(object.multipolygon)
      : undefined;
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? ViewBox.fromPartial(object.polygon)
      : undefined;
    return message;
  },
};

function createBaseDatasetSampleReq(): DatasetSampleReq {
  return {
    dataSourceId: "",
    organizationId: "",
    maxRows: 0,
    maxPercentage: 0,
    sampleId: "",
    dggsColumn: "",
    polygon: undefined,
    resolution: undefined,
    collection: "",
    sampleDataSourceId: "",
  };
}

export const DatasetSampleReq: MessageFns<DatasetSampleReq> = {
  encode(message: DatasetSampleReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataSourceId !== "") {
      writer.uint32(10).string(message.dataSourceId);
    }
    if (message.organizationId !== "") {
      writer.uint32(18).string(message.organizationId);
    }
    if (message.maxRows !== 0) {
      writer.uint32(24).int32(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      writer.uint32(32).int32(message.maxPercentage);
    }
    if (message.sampleId !== "") {
      writer.uint32(42).string(message.sampleId);
    }
    if (message.dggsColumn !== "") {
      writer.uint32(50).string(message.dggsColumn);
    }
    if (message.polygon !== undefined) {
      ViewBox.encode(message.polygon, writer.uint32(58).fork()).join();
    }
    if (message.resolution !== undefined) {
      writer.uint32(64).int32(message.resolution);
    }
    if (message.collection !== "") {
      writer.uint32(74).string(message.collection);
    }
    if (message.sampleDataSourceId !== "") {
      writer.uint32(82).string(message.sampleDataSourceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetSampleReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetSampleReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataSourceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxRows = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxPercentage = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sampleId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.dggsColumn = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.polygon = ViewBox.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.resolution = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.sampleDataSourceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetSampleReq {
    return {
      dataSourceId: isSet(object.dataSourceId) ? globalThis.String(object.dataSourceId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      maxRows: isSet(object.maxRows) ? globalThis.Number(object.maxRows) : 0,
      maxPercentage: isSet(object.maxPercentage) ? globalThis.Number(object.maxPercentage) : 0,
      sampleId: isSet(object.sampleId) ? globalThis.String(object.sampleId) : "",
      dggsColumn: isSet(object.dggsColumn) ? globalThis.String(object.dggsColumn) : "",
      polygon: isSet(object.polygon) ? ViewBox.fromJSON(object.polygon) : undefined,
      resolution: isSet(object.resolution) ? globalThis.Number(object.resolution) : undefined,
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
      sampleDataSourceId: isSet(object.sampleDataSourceId) ? globalThis.String(object.sampleDataSourceId) : "",
    };
  },

  toJSON(message: DatasetSampleReq): unknown {
    const obj: any = {};
    if (message.dataSourceId !== "") {
      obj.dataSourceId = message.dataSourceId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.maxRows !== 0) {
      obj.maxRows = Math.round(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      obj.maxPercentage = Math.round(message.maxPercentage);
    }
    if (message.sampleId !== "") {
      obj.sampleId = message.sampleId;
    }
    if (message.dggsColumn !== "") {
      obj.dggsColumn = message.dggsColumn;
    }
    if (message.polygon !== undefined) {
      obj.polygon = ViewBox.toJSON(message.polygon);
    }
    if (message.resolution !== undefined) {
      obj.resolution = Math.round(message.resolution);
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    if (message.sampleDataSourceId !== "") {
      obj.sampleDataSourceId = message.sampleDataSourceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetSampleReq>, I>>(base?: I): DatasetSampleReq {
    return DatasetSampleReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetSampleReq>, I>>(object: I): DatasetSampleReq {
    const message = createBaseDatasetSampleReq();
    message.dataSourceId = object.dataSourceId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.maxRows = object.maxRows ?? 0;
    message.maxPercentage = object.maxPercentage ?? 0;
    message.sampleId = object.sampleId ?? "";
    message.dggsColumn = object.dggsColumn ?? "";
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? ViewBox.fromPartial(object.polygon)
      : undefined;
    message.resolution = object.resolution ?? undefined;
    message.collection = object.collection ?? "";
    message.sampleDataSourceId = object.sampleDataSourceId ?? "";
    return message;
  },
};

function createBaseDatasetSampleRsp(): DatasetSampleRsp {
  return { status: 0, success: undefined, err: undefined };
}

export const DatasetSampleRsp: MessageFns<DatasetSampleRsp> = {
  encode(message: DatasetSampleRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.success !== undefined) {
      DatasetSampleRspSuccess.encode(message.success, writer.uint32(18).fork()).join();
    }
    if (message.err !== undefined) {
      AuroraError.encode(message.err, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetSampleRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetSampleRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.success = DatasetSampleRspSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.err = AuroraError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetSampleRsp {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      success: isSet(object.success) ? DatasetSampleRspSuccess.fromJSON(object.success) : undefined,
      err: isSet(object.err) ? AuroraError.fromJSON(object.err) : undefined,
    };
  },

  toJSON(message: DatasetSampleRsp): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = statusToJSON(message.status);
    }
    if (message.success !== undefined) {
      obj.success = DatasetSampleRspSuccess.toJSON(message.success);
    }
    if (message.err !== undefined) {
      obj.err = AuroraError.toJSON(message.err);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetSampleRsp>, I>>(base?: I): DatasetSampleRsp {
    return DatasetSampleRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetSampleRsp>, I>>(object: I): DatasetSampleRsp {
    const message = createBaseDatasetSampleRsp();
    message.status = object.status ?? 0;
    message.success = (object.success !== undefined && object.success !== null)
      ? DatasetSampleRspSuccess.fromPartial(object.success)
      : undefined;
    message.err = (object.err !== undefined && object.err !== null) ? AuroraError.fromPartial(object.err) : undefined;
    return message;
  },
};

function createBaseDatasetSampleRspSuccess(): DatasetSampleRspSuccess {
  return { dataSourceId: "", organizationId: "", sampleId: "", collection: "", sampleDataSourceId: "" };
}

export const DatasetSampleRspSuccess: MessageFns<DatasetSampleRspSuccess> = {
  encode(message: DatasetSampleRspSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataSourceId !== "") {
      writer.uint32(10).string(message.dataSourceId);
    }
    if (message.organizationId !== "") {
      writer.uint32(18).string(message.organizationId);
    }
    if (message.sampleId !== "") {
      writer.uint32(26).string(message.sampleId);
    }
    if (message.collection !== "") {
      writer.uint32(34).string(message.collection);
    }
    if (message.sampleDataSourceId !== "") {
      writer.uint32(42).string(message.sampleDataSourceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetSampleRspSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetSampleRspSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataSourceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.sampleId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sampleDataSourceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetSampleRspSuccess {
    return {
      dataSourceId: isSet(object.dataSourceId) ? globalThis.String(object.dataSourceId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      sampleId: isSet(object.sampleId) ? globalThis.String(object.sampleId) : "",
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
      sampleDataSourceId: isSet(object.sampleDataSourceId) ? globalThis.String(object.sampleDataSourceId) : "",
    };
  },

  toJSON(message: DatasetSampleRspSuccess): unknown {
    const obj: any = {};
    if (message.dataSourceId !== "") {
      obj.dataSourceId = message.dataSourceId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.sampleId !== "") {
      obj.sampleId = message.sampleId;
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    if (message.sampleDataSourceId !== "") {
      obj.sampleDataSourceId = message.sampleDataSourceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetSampleRspSuccess>, I>>(base?: I): DatasetSampleRspSuccess {
    return DatasetSampleRspSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetSampleRspSuccess>, I>>(object: I): DatasetSampleRspSuccess {
    const message = createBaseDatasetSampleRspSuccess();
    message.dataSourceId = object.dataSourceId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.sampleId = object.sampleId ?? "";
    message.collection = object.collection ?? "";
    message.sampleDataSourceId = object.sampleDataSourceId ?? "";
    return message;
  },
};

function createBaseDatasetSampleGenerationReq(): DatasetSampleGenerationReq {
  return { dataPath: "", generatedFileName: "", dggsColumn: "", maxRows: 0, maxPercentage: 0, resolution: undefined };
}

export const DatasetSampleGenerationReq: MessageFns<DatasetSampleGenerationReq> = {
  encode(message: DatasetSampleGenerationReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataPath !== "") {
      writer.uint32(10).string(message.dataPath);
    }
    if (message.generatedFileName !== "") {
      writer.uint32(18).string(message.generatedFileName);
    }
    if (message.dggsColumn !== "") {
      writer.uint32(26).string(message.dggsColumn);
    }
    if (message.maxRows !== 0) {
      writer.uint32(32).int32(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      writer.uint32(40).int32(message.maxPercentage);
    }
    if (message.resolution !== undefined) {
      writer.uint32(48).int32(message.resolution);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetSampleGenerationReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetSampleGenerationReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.generatedFileName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dggsColumn = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxRows = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxPercentage = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.resolution = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetSampleGenerationReq {
    return {
      dataPath: isSet(object.dataPath) ? globalThis.String(object.dataPath) : "",
      generatedFileName: isSet(object.generatedFileName) ? globalThis.String(object.generatedFileName) : "",
      dggsColumn: isSet(object.dggsColumn) ? globalThis.String(object.dggsColumn) : "",
      maxRows: isSet(object.maxRows) ? globalThis.Number(object.maxRows) : 0,
      maxPercentage: isSet(object.maxPercentage) ? globalThis.Number(object.maxPercentage) : 0,
      resolution: isSet(object.resolution) ? globalThis.Number(object.resolution) : undefined,
    };
  },

  toJSON(message: DatasetSampleGenerationReq): unknown {
    const obj: any = {};
    if (message.dataPath !== "") {
      obj.dataPath = message.dataPath;
    }
    if (message.generatedFileName !== "") {
      obj.generatedFileName = message.generatedFileName;
    }
    if (message.dggsColumn !== "") {
      obj.dggsColumn = message.dggsColumn;
    }
    if (message.maxRows !== 0) {
      obj.maxRows = Math.round(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      obj.maxPercentage = Math.round(message.maxPercentage);
    }
    if (message.resolution !== undefined) {
      obj.resolution = Math.round(message.resolution);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetSampleGenerationReq>, I>>(base?: I): DatasetSampleGenerationReq {
    return DatasetSampleGenerationReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetSampleGenerationReq>, I>>(object: I): DatasetSampleGenerationReq {
    const message = createBaseDatasetSampleGenerationReq();
    message.dataPath = object.dataPath ?? "";
    message.generatedFileName = object.generatedFileName ?? "";
    message.dggsColumn = object.dggsColumn ?? "";
    message.maxRows = object.maxRows ?? 0;
    message.maxPercentage = object.maxPercentage ?? 0;
    message.resolution = object.resolution ?? undefined;
    return message;
  },
};

function createBasePointDataRsp(): PointDataRsp {
  return { status: 0, success: undefined, err: undefined };
}

export const PointDataRsp: MessageFns<PointDataRsp> = {
  encode(message: PointDataRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.success !== undefined) {
      PointDataRspSuccess.encode(message.success, writer.uint32(18).fork()).join();
    }
    if (message.err !== undefined) {
      AuroraError.encode(message.err, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointDataRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointDataRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.success = PointDataRspSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.err = AuroraError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointDataRsp {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      success: isSet(object.success) ? PointDataRspSuccess.fromJSON(object.success) : undefined,
      err: isSet(object.err) ? AuroraError.fromJSON(object.err) : undefined,
    };
  },

  toJSON(message: PointDataRsp): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = statusToJSON(message.status);
    }
    if (message.success !== undefined) {
      obj.success = PointDataRspSuccess.toJSON(message.success);
    }
    if (message.err !== undefined) {
      obj.err = AuroraError.toJSON(message.err);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointDataRsp>, I>>(base?: I): PointDataRsp {
    return PointDataRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointDataRsp>, I>>(object: I): PointDataRsp {
    const message = createBasePointDataRsp();
    message.status = object.status ?? 0;
    message.success = (object.success !== undefined && object.success !== null)
      ? PointDataRspSuccess.fromPartial(object.success)
      : undefined;
    message.err = (object.err !== undefined && object.err !== null) ? AuroraError.fromPartial(object.err) : undefined;
    return message;
  },
};

function createBasePointDataRspSuccess(): PointDataRspSuccess {
  return { row: [] };
}

export const PointDataRspSuccess: MessageFns<PointDataRspSuccess> = {
  encode(message: PointDataRspSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.row) {
      Struct.encode(Struct.wrap(v!), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointDataRspSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointDataRspSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.row.push(Struct.unwrap(Struct.decode(reader, reader.uint32())));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointDataRspSuccess {
    return { row: globalThis.Array.isArray(object?.row) ? [...object.row] : [] };
  },

  toJSON(message: PointDataRspSuccess): unknown {
    const obj: any = {};
    if (message.row?.length) {
      obj.row = message.row;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointDataRspSuccess>, I>>(base?: I): PointDataRspSuccess {
    return PointDataRspSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointDataRspSuccess>, I>>(object: I): PointDataRspSuccess {
    const message = createBasePointDataRspSuccess();
    message.row = object.row?.map((e) => e) || [];
    return message;
  },
};

function createBasePointDataReq(): PointDataReq {
  return { tableId: "", id: "", organizationId: "", databaseId: "", collection: "" };
}

export const PointDataReq: MessageFns<PointDataReq> = {
  encode(message: PointDataReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tableId !== "") {
      writer.uint32(10).string(message.tableId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.organizationId !== "") {
      writer.uint32(26).string(message.organizationId);
    }
    if (message.databaseId !== "") {
      writer.uint32(34).string(message.databaseId);
    }
    if (message.collection !== "") {
      writer.uint32(42).string(message.collection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PointDataReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointDataReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tableId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.databaseId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PointDataReq {
    return {
      tableId: isSet(object.tableId) ? globalThis.String(object.tableId) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      databaseId: isSet(object.databaseId) ? globalThis.String(object.databaseId) : "",
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
    };
  },

  toJSON(message: PointDataReq): unknown {
    const obj: any = {};
    if (message.tableId !== "") {
      obj.tableId = message.tableId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.databaseId !== "") {
      obj.databaseId = message.databaseId;
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PointDataReq>, I>>(base?: I): PointDataReq {
    return PointDataReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointDataReq>, I>>(object: I): PointDataReq {
    const message = createBasePointDataReq();
    message.tableId = object.tableId ?? "";
    message.id = object.id ?? "";
    message.organizationId = object.organizationId ?? "";
    message.databaseId = object.databaseId ?? "";
    message.collection = object.collection ?? "";
    return message;
  },
};

function createBaseDatasetLiveSampleReq(): DatasetLiveSampleReq {
  return {
    dataSourceId: "",
    organizationId: "",
    geographyColumn: "",
    dggsColumn: "",
    maxRows: 0,
    maxPercentage: 0,
    polygon: undefined,
    resolution: undefined,
    collection: "",
  };
}

export const DatasetLiveSampleReq: MessageFns<DatasetLiveSampleReq> = {
  encode(message: DatasetLiveSampleReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataSourceId !== "") {
      writer.uint32(10).string(message.dataSourceId);
    }
    if (message.organizationId !== "") {
      writer.uint32(18).string(message.organizationId);
    }
    if (message.geographyColumn !== "") {
      writer.uint32(26).string(message.geographyColumn);
    }
    if (message.dggsColumn !== "") {
      writer.uint32(34).string(message.dggsColumn);
    }
    if (message.maxRows !== 0) {
      writer.uint32(40).int32(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      writer.uint32(48).int32(message.maxPercentage);
    }
    if (message.polygon !== undefined) {
      ViewBox.encode(message.polygon, writer.uint32(58).fork()).join();
    }
    if (message.resolution !== undefined) {
      writer.uint32(64).int32(message.resolution);
    }
    if (message.collection !== "") {
      writer.uint32(74).string(message.collection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetLiveSampleReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetLiveSampleReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataSourceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.geographyColumn = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dggsColumn = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxRows = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxPercentage = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.polygon = ViewBox.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.resolution = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.collection = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetLiveSampleReq {
    return {
      dataSourceId: isSet(object.dataSourceId) ? globalThis.String(object.dataSourceId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      geographyColumn: isSet(object.geographyColumn) ? globalThis.String(object.geographyColumn) : "",
      dggsColumn: isSet(object.dggsColumn) ? globalThis.String(object.dggsColumn) : "",
      maxRows: isSet(object.maxRows) ? globalThis.Number(object.maxRows) : 0,
      maxPercentage: isSet(object.maxPercentage) ? globalThis.Number(object.maxPercentage) : 0,
      polygon: isSet(object.polygon) ? ViewBox.fromJSON(object.polygon) : undefined,
      resolution: isSet(object.resolution) ? globalThis.Number(object.resolution) : undefined,
      collection: isSet(object.collection) ? globalThis.String(object.collection) : "",
    };
  },

  toJSON(message: DatasetLiveSampleReq): unknown {
    const obj: any = {};
    if (message.dataSourceId !== "") {
      obj.dataSourceId = message.dataSourceId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.geographyColumn !== "") {
      obj.geographyColumn = message.geographyColumn;
    }
    if (message.dggsColumn !== "") {
      obj.dggsColumn = message.dggsColumn;
    }
    if (message.maxRows !== 0) {
      obj.maxRows = Math.round(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      obj.maxPercentage = Math.round(message.maxPercentage);
    }
    if (message.polygon !== undefined) {
      obj.polygon = ViewBox.toJSON(message.polygon);
    }
    if (message.resolution !== undefined) {
      obj.resolution = Math.round(message.resolution);
    }
    if (message.collection !== "") {
      obj.collection = message.collection;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetLiveSampleReq>, I>>(base?: I): DatasetLiveSampleReq {
    return DatasetLiveSampleReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetLiveSampleReq>, I>>(object: I): DatasetLiveSampleReq {
    const message = createBaseDatasetLiveSampleReq();
    message.dataSourceId = object.dataSourceId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.geographyColumn = object.geographyColumn ?? "";
    message.dggsColumn = object.dggsColumn ?? "";
    message.maxRows = object.maxRows ?? 0;
    message.maxPercentage = object.maxPercentage ?? 0;
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? ViewBox.fromPartial(object.polygon)
      : undefined;
    message.resolution = object.resolution ?? undefined;
    message.collection = object.collection ?? "";
    return message;
  },
};

function createBaseDatasetLiveSampleReqSubset(): DatasetLiveSampleReqSubset {
  return { geographyColumn: "", dggsColumn: "", maxRows: 0, maxPercentage: 0, resolution: undefined };
}

export const DatasetLiveSampleReqSubset: MessageFns<DatasetLiveSampleReqSubset> = {
  encode(message: DatasetLiveSampleReqSubset, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.geographyColumn !== "") {
      writer.uint32(10).string(message.geographyColumn);
    }
    if (message.dggsColumn !== "") {
      writer.uint32(18).string(message.dggsColumn);
    }
    if (message.maxRows !== 0) {
      writer.uint32(24).int32(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      writer.uint32(32).int32(message.maxPercentage);
    }
    if (message.resolution !== undefined) {
      writer.uint32(40).int32(message.resolution);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetLiveSampleReqSubset {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetLiveSampleReqSubset();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.geographyColumn = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.dggsColumn = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxRows = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxPercentage = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.resolution = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetLiveSampleReqSubset {
    return {
      geographyColumn: isSet(object.geographyColumn) ? globalThis.String(object.geographyColumn) : "",
      dggsColumn: isSet(object.dggsColumn) ? globalThis.String(object.dggsColumn) : "",
      maxRows: isSet(object.maxRows) ? globalThis.Number(object.maxRows) : 0,
      maxPercentage: isSet(object.maxPercentage) ? globalThis.Number(object.maxPercentage) : 0,
      resolution: isSet(object.resolution) ? globalThis.Number(object.resolution) : undefined,
    };
  },

  toJSON(message: DatasetLiveSampleReqSubset): unknown {
    const obj: any = {};
    if (message.geographyColumn !== "") {
      obj.geographyColumn = message.geographyColumn;
    }
    if (message.dggsColumn !== "") {
      obj.dggsColumn = message.dggsColumn;
    }
    if (message.maxRows !== 0) {
      obj.maxRows = Math.round(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      obj.maxPercentage = Math.round(message.maxPercentage);
    }
    if (message.resolution !== undefined) {
      obj.resolution = Math.round(message.resolution);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetLiveSampleReqSubset>, I>>(base?: I): DatasetLiveSampleReqSubset {
    return DatasetLiveSampleReqSubset.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetLiveSampleReqSubset>, I>>(object: I): DatasetLiveSampleReqSubset {
    const message = createBaseDatasetLiveSampleReqSubset();
    message.geographyColumn = object.geographyColumn ?? "";
    message.dggsColumn = object.dggsColumn ?? "";
    message.maxRows = object.maxRows ?? 0;
    message.maxPercentage = object.maxPercentage ?? 0;
    message.resolution = object.resolution ?? undefined;
    return message;
  },
};

function createBaseDatasetLiveSampleRsp(): DatasetLiveSampleRsp {
  return { status: 0, success: undefined, err: undefined };
}

export const DatasetLiveSampleRsp: MessageFns<DatasetLiveSampleRsp> = {
  encode(message: DatasetLiveSampleRsp, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.success !== undefined) {
      DatasetLiveSampleRspSuccess.encode(message.success, writer.uint32(18).fork()).join();
    }
    if (message.err !== undefined) {
      AuroraError.encode(message.err, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetLiveSampleRsp {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetLiveSampleRsp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.success = DatasetLiveSampleRspSuccess.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.err = AuroraError.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetLiveSampleRsp {
    return {
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      success: isSet(object.success) ? DatasetLiveSampleRspSuccess.fromJSON(object.success) : undefined,
      err: isSet(object.err) ? AuroraError.fromJSON(object.err) : undefined,
    };
  },

  toJSON(message: DatasetLiveSampleRsp): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = statusToJSON(message.status);
    }
    if (message.success !== undefined) {
      obj.success = DatasetLiveSampleRspSuccess.toJSON(message.success);
    }
    if (message.err !== undefined) {
      obj.err = AuroraError.toJSON(message.err);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetLiveSampleRsp>, I>>(base?: I): DatasetLiveSampleRsp {
    return DatasetLiveSampleRsp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetLiveSampleRsp>, I>>(object: I): DatasetLiveSampleRsp {
    const message = createBaseDatasetLiveSampleRsp();
    message.status = object.status ?? 0;
    message.success = (object.success !== undefined && object.success !== null)
      ? DatasetLiveSampleRspSuccess.fromPartial(object.success)
      : undefined;
    message.err = (object.err !== undefined && object.err !== null) ? AuroraError.fromPartial(object.err) : undefined;
    return message;
  },
};

function createBaseDatasetLiveSampleGeometry(): DatasetLiveSampleGeometry {
  return { points: [] };
}

export const DatasetLiveSampleGeometry: MessageFns<DatasetLiveSampleGeometry> = {
  encode(message: DatasetLiveSampleGeometry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.points) {
      Struct.encode(Struct.wrap(v!), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetLiveSampleGeometry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetLiveSampleGeometry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.points.push(Struct.unwrap(Struct.decode(reader, reader.uint32())));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetLiveSampleGeometry {
    return { points: globalThis.Array.isArray(object?.points) ? [...object.points] : [] };
  },

  toJSON(message: DatasetLiveSampleGeometry): unknown {
    const obj: any = {};
    if (message.points?.length) {
      obj.points = message.points;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetLiveSampleGeometry>, I>>(base?: I): DatasetLiveSampleGeometry {
    return DatasetLiveSampleGeometry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetLiveSampleGeometry>, I>>(object: I): DatasetLiveSampleGeometry {
    const message = createBaseDatasetLiveSampleGeometry();
    message.points = object.points?.map((e) => e) || [];
    return message;
  },
};

function createBaseDatasetLiveSampleRspSuccess(): DatasetLiveSampleRspSuccess {
  return { dataSourceId: "", organizationId: "", geometry: undefined };
}

export const DatasetLiveSampleRspSuccess: MessageFns<DatasetLiveSampleRspSuccess> = {
  encode(message: DatasetLiveSampleRspSuccess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataSourceId !== "") {
      writer.uint32(10).string(message.dataSourceId);
    }
    if (message.organizationId !== "") {
      writer.uint32(18).string(message.organizationId);
    }
    if (message.geometry !== undefined) {
      DatasetLiveSampleGeometry.encode(message.geometry, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetLiveSampleRspSuccess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetLiveSampleRspSuccess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataSourceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.organizationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.geometry = DatasetLiveSampleGeometry.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetLiveSampleRspSuccess {
    return {
      dataSourceId: isSet(object.dataSourceId) ? globalThis.String(object.dataSourceId) : "",
      organizationId: isSet(object.organizationId) ? globalThis.String(object.organizationId) : "",
      geometry: isSet(object.geometry) ? DatasetLiveSampleGeometry.fromJSON(object.geometry) : undefined,
    };
  },

  toJSON(message: DatasetLiveSampleRspSuccess): unknown {
    const obj: any = {};
    if (message.dataSourceId !== "") {
      obj.dataSourceId = message.dataSourceId;
    }
    if (message.organizationId !== "") {
      obj.organizationId = message.organizationId;
    }
    if (message.geometry !== undefined) {
      obj.geometry = DatasetLiveSampleGeometry.toJSON(message.geometry);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetLiveSampleRspSuccess>, I>>(base?: I): DatasetLiveSampleRspSuccess {
    return DatasetLiveSampleRspSuccess.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetLiveSampleRspSuccess>, I>>(object: I): DatasetLiveSampleRspSuccess {
    const message = createBaseDatasetLiveSampleRspSuccess();
    message.dataSourceId = object.dataSourceId ?? "";
    message.organizationId = object.organizationId ?? "";
    message.geometry = (object.geometry !== undefined && object.geometry !== null)
      ? DatasetLiveSampleGeometry.fromPartial(object.geometry)
      : undefined;
    return message;
  },
};

function createBaseDatasetLiveSampleGenerationReq(): DatasetLiveSampleGenerationReq {
  return { dataPath: "", geographyColumn: "", dggsColumn: "", maxRows: 0, maxPercentage: 0, resolution: undefined };
}

export const DatasetLiveSampleGenerationReq: MessageFns<DatasetLiveSampleGenerationReq> = {
  encode(message: DatasetLiveSampleGenerationReq, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.dataPath !== "") {
      writer.uint32(10).string(message.dataPath);
    }
    if (message.geographyColumn !== "") {
      writer.uint32(18).string(message.geographyColumn);
    }
    if (message.dggsColumn !== "") {
      writer.uint32(26).string(message.dggsColumn);
    }
    if (message.maxRows !== 0) {
      writer.uint32(32).int32(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      writer.uint32(40).int32(message.maxPercentage);
    }
    if (message.resolution !== undefined) {
      writer.uint32(48).int32(message.resolution);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DatasetLiveSampleGenerationReq {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDatasetLiveSampleGenerationReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.dataPath = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.geographyColumn = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dggsColumn = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.maxRows = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.maxPercentage = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.resolution = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DatasetLiveSampleGenerationReq {
    return {
      dataPath: isSet(object.dataPath) ? globalThis.String(object.dataPath) : "",
      geographyColumn: isSet(object.geographyColumn) ? globalThis.String(object.geographyColumn) : "",
      dggsColumn: isSet(object.dggsColumn) ? globalThis.String(object.dggsColumn) : "",
      maxRows: isSet(object.maxRows) ? globalThis.Number(object.maxRows) : 0,
      maxPercentage: isSet(object.maxPercentage) ? globalThis.Number(object.maxPercentage) : 0,
      resolution: isSet(object.resolution) ? globalThis.Number(object.resolution) : undefined,
    };
  },

  toJSON(message: DatasetLiveSampleGenerationReq): unknown {
    const obj: any = {};
    if (message.dataPath !== "") {
      obj.dataPath = message.dataPath;
    }
    if (message.geographyColumn !== "") {
      obj.geographyColumn = message.geographyColumn;
    }
    if (message.dggsColumn !== "") {
      obj.dggsColumn = message.dggsColumn;
    }
    if (message.maxRows !== 0) {
      obj.maxRows = Math.round(message.maxRows);
    }
    if (message.maxPercentage !== 0) {
      obj.maxPercentage = Math.round(message.maxPercentage);
    }
    if (message.resolution !== undefined) {
      obj.resolution = Math.round(message.resolution);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DatasetLiveSampleGenerationReq>, I>>(base?: I): DatasetLiveSampleGenerationReq {
    return DatasetLiveSampleGenerationReq.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DatasetLiveSampleGenerationReq>, I>>(
    object: I,
  ): DatasetLiveSampleGenerationReq {
    const message = createBaseDatasetLiveSampleGenerationReq();
    message.dataPath = object.dataPath ?? "";
    message.geographyColumn = object.geographyColumn ?? "";
    message.dggsColumn = object.dggsColumn ?? "";
    message.maxRows = object.maxRows ?? 0;
    message.maxPercentage = object.maxPercentage ?? 0;
    message.resolution = object.resolution ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
